// extracted by mini-css-extract-plugin
export var cell = "_5k-4";
export var headerCell = "_5k-2";
export var rowHeader = "_5k-3";
export var table = "_5k-1";
export var tableContainer = "_5k-0";